import { DateTimeFormatter } from '@nile/components/src';
import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { FormattedMessage } from 'react-intl';

const CreatedByBubble = (props) => {
  const { message } = props;

  return (
    <TextStyle variation="subdued">
      <div className="fsize12 pl20 pb20">
        <FormattedMessage
          id={`${message?.message}`}
          values={{
            name: message?.user?.name,
            time: <DateTimeFormatter type="dateTime" date={message?.time} />,
            b: (chunks) => <b>{chunks}</b>
          }}
        />
      </div>
    </TextStyle>
  );
};

export default withErrorBoundary(CreatedByBubble);
